/** Une ligne de prescription : un médicament avec sa dose et sa durée. */
export class LigneOrdonnance {
	medicament: string;
	dose: string;
	duree: string;
}

export class Ordonnance {
	id?: string;
	ferme: string;
	dateOrdonnance: string; // yyyy-MM-dd
	numCage: string;
	temperatureEau: string;
	lignes?: LigneOrdonnance[];
	medicament: string; // noms des médicaments joints par « + » : affichage en liste et règle Firestore
	dose?: string; // anciennes ordonnances à un seul médicament (avant `lignes`)
	duree?: string;
	voieAdministration: string;
	recommandations: string;
	veterinaireNom: string;
	veterinaireOrdre: string;
	veterinaireAdresse: string;
	examenId?: string; // examen d'origine quand l'ordonnance est créée depuis un examen
	dateCreation?: string;
}

/** Lignes de prescription, y compris pour une ancienne ordonnance à un seul médicament. */
export function lignesDe(o: Ordonnance): LigneOrdonnance[] {
	return o.lignes && o.lignes.length
		? o.lignes
		: [{ medicament: o.medicament, dose: o.dose || '', duree: o.duree || '' }];
}
